
<template>
    <div id="canvas-container" style="z-index: 1; text-align: center; background-color:#ccc; width: 100%; height: auto;">
          <div id="loadingContent" class="loadingContent" v-bind:class="{ visible: !canvasReady }">
            <div class="modal-loadingContent">
              <img class="loading-gif" src="@/assets/images/tramite/loading.gif" alt="loading" style="height: 35px;">
              <p>Desencriptando...</p>
            </div>
          </div>
<!--        <b-overlay-->
<!--          :show="!canvasReady"-->
<!--          opacity="0.50"-->
<!--          rounded="sm"-->
<!--          spinner-variant="primary"-->
<!--          spinner-type="grow"-->
<!--        >-->
            <canvas ref="thecanvas" id="the-canvas" class="center-container" style="height: 100%; width: 100%; background-color:#ccc;"></canvas>
<!--        </b-overlay>-->
    </div>
</template>
<script>
    import dragndrop from './dragndrop.vue'

    export default {
        components:{
            dragndrop
        },
        name: 'PDFViewer',
        props:{
            // controlesProp,
            urlProp: String,
            singlePageProp: Boolean,
            padre: Object
        },
        data(){
            return {
                pdfjs: null,
                pdfjsWorker: null,
                pdfDoc : null,
                pageNum : 1,
                pageRendering : false,
                pageNumPending : null,
                scale : 1,
                url: this.urlProp,
                control:{
                    id:'new_'+String(Date.now()),
                    x:100,
                    y:100,
                    colorProp: 'blue',
                    labelProp: '',
                    archivo: {id: 1},
                    firmante: {id: 1},
                    width:40,
                    height: 40
                },
                canvasReady: false,
                singlePage: false
                // controles: this.controlesProp,
            }
        },
        methods:{
            async setPdfJs(){
                this.pdfjs = await import('pdfjs-dist/build/pdf').then(res => {return res});
                this.pdfjsWorker = await import('pdfjs-dist/build/pdf.worker.entry').then(res => {return res});
                this.pdfjs.GlobalWorkerOptions.workerSrc = this.pdfjsWorker;
            },

            async renderPage(num) {
                var scale = 2.5;
                var canvas = await this.canvas;
                const that = this;
                var pageNumPending = this.pageNumPending;
                this.pageRendering = true;

                // Using promise to fetch the page
                this.canvas = this.$refs.thecanvas;
                if(!this.singlePage){
                document.getElementById('prev').addEventListener('click', this.onPrevPage);
                document.getElementById('next').addEventListener('click', this.onNextPage);
                }
                this.pdfDoc.getPage(num).then(function(page) {
                    var viewport = page.getViewport({scale: scale});
                    var renderContext = {
                        canvasContext: canvas.getContext('2d'),
                        viewport: viewport
                    };
                    var renderTask = page.render(renderContext);
                    renderTask.promise.then(function() {
                        if (pageNumPending !== null) {
                            that.renderPage(pageNumPending);
                            pageNumPending = null;
                        }
                    });
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                });
                this.pageRendering = false;
                this.pageNumPending = pageNumPending;
                if(this.singlePage){}else{
                    document.getElementById('page_num').value = num;
                }
                return num
            },

            queueRenderPage(num) {
                if (this.pageRendering) {
                    // console.log("if page num pending")
                    this.pageNumPending = num;
                } else {
                    // console.log("else render page")
                    this.renderPage(num);
                }
            },

            onPrevPage() {
                if (this.pageNum <= 1) {
                    return;
                }
                this.pageNum--;
                this.queueRenderPage(this.pageNum);
            },

            onNextPage() {
                if (this.pageNum >= this.pdfDoc.numPages) {
                    return;
                }
                this.pageNum++;
                this.queueRenderPage(this.pageNum);
            },
            onTarget(page){
                try{
                    this.pageNum = page
                    this.queueRenderPage(page);
                }catch(error){
                    console.log(error)
                    console.log('Error Rendering Page')
                }
            }
        },
        async mounted(){
            let that = this
            if(this.singlePageProp){this.singlePage=this.singlePageProp}else{this.singlePage = false}
            this.canvas = await this.$refs.thecanvas
            await this.setPdfJs();
            var pdfDoc = null;
            let parent = this
            let usuario_saved=this.$cookie.get('usuario')
                let userJson=JSON.parse(usuario_saved)
                await this.pdfjs.getDocument({
                    url: this.urlProp,
                    // httpHeaders: { Authorization: 'Token ' + userJson.token }
                }).promise.then(function(pdfDoc_) {
                    pdfDoc = pdfDoc_;
                    if(parent.singlePage){}else{
                        document.getElementById('page_count').textContent = pdfDoc.numPages;
                    }
                    try{that.padre.cargarControles()}catch(error){console.log(error)}
                });
            this.pdfDoc = pdfDoc
            // console.log("this pdfdoc--------->")
            // console.log(this.pdfDoc)
            await this.renderPage(this.pageNum);
            this.canvasReady = await true;
        },
    }

</script>
<style lang="scss" scoped>
    #the-canvas{
        min-height: 857px;
    }

    @media (max-width: 900px) {
        #the-canvas{
            min-height: 80vh;
        }
    }
</style>

<style>
    /* The Modal (background) */
    .loadingContent {
      display: none; /* Hidden by default */
      z-index: 1; /* Sit on top */
      left: 0;
      top: 0;
      width: 100%; /* Full width */
      height: 94%; /* Full height */
      overflow: hidden; /* Enable scroll if needed */
      background-color: rgb(0,0,0); /* Fallback color */
      background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content/Box */
    .modal-loadingContent {
      background-color: #fefefe;
      margin: 12% auto; /* 12% from the top and centered */
      padding: 3%;
      border: 1px solid #888;
      width: 50%; /* Could be more or less, depending on screen size */
      height: 30%;
      text-align: center;
      font-size: 20px;
      /* font-weight: bold; */
      border-radius: 7px;
      max-height: 175px;
    }
</style>
